import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow } from "vue";
const _hoisted_1 = { class: "content-builder" };
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = { class: "form-group" };
const _hoisted_6 = { class: "form-group" };
const _hoisted_7 = { class: "input-group" };
const _hoisted_8 = { class: "form-group" };
const _hoisted_9 = { class: "form-group" };
const _hoisted_10 = { class: "row" };
const _hoisted_11 = { class: "col-6" };
const _hoisted_12 = { class: "form-group" };
const _hoisted_13 = { class: "form-group" };
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = { class: "form-group" };
const _hoisted_16 = { class: "col-6" };
const _hoisted_17 = { class: "form-group" };
const _hoisted_18 = {
    key: 0,
    class: "form-group mt-4"
};
const _hoisted_19 = { class: "row" };
const _hoisted_20 = { class: "col-6" };
const _hoisted_21 = { class: "col-6" };
const _hoisted_22 = { class: "form-group" };
const _hoisted_23 = {
    key: 1,
    class: "form-group"
};
const _hoisted_24 = { class: "table table-striped table-bordered" };
const _hoisted_25 = ["onUpdate:modelValue"];
const _hoisted_26 = ["onUpdate:modelValue"];
const _hoisted_27 = ["onClick"];
const _hoisted_28 = { class: "form-group" };
const _hoisted_29 = { class: "form-group" };
const _hoisted_30 = { class: "form-group" };
const _hoisted_31 = { class: "form-group card-metrics" };
const _hoisted_32 = { class: "row d-flex align-items-center" };
const _hoisted_33 = { class: "col-10" };
const _hoisted_34 = { class: "row" };
const _hoisted_35 = { class: "col-sm" };
const _hoisted_36 = ["id", "onUpdate:modelValue"];
const _hoisted_37 = { class: "form-group card-metrics" };
const _hoisted_38 = { class: "row d-flex align-items-center" };
const _hoisted_39 = { class: "col-10" };
const _hoisted_40 = { class: "row" };
const _hoisted_41 = { class: "col-sm" };
const _hoisted_42 = ["id", "onUpdate:modelValue"];
const _hoisted_43 = { class: "form-group card-metrics" };
const _hoisted_44 = { class: "row d-flex align-items-center" };
const _hoisted_45 = { class: "col-10" };
const _hoisted_46 = { class: "row" };
const _hoisted_47 = { class: "col-sm" };
const _hoisted_48 = ["id", "onUpdate:modelValue"];
const _hoisted_49 = { class: "form-group card-metrics" };
const _hoisted_50 = { class: "row d-flex align-items-center" };
const _hoisted_51 = { class: "col-10" };
const _hoisted_52 = { class: "row" };
const _hoisted_53 = { class: "col-sm" };
const _hoisted_54 = ["id", "onUpdate:modelValue"];
const _hoisted_55 = { class: "form-group" };
const _hoisted_56 = { class: "actions" };
const _hoisted_57 = { class: "action-item" };
const _hoisted_58 = { class: "action-item" };
const _hoisted_59 = { class: "action-item" };
const _hoisted_60 = { class: "action-item" };
const _hoisted_61 = { class: "form-group" };
const _hoisted_62 = { class: "form-group" };
const _hoisted_63 = { class: "content-list" };
const _hoisted_64 = { class: "card-header text-center font-weight-bold" };
const _hoisted_65 = { class: "card-body" };
const _hoisted_66 = { class: "form-group" };
const _hoisted_67 = { class: "" };
const _hoisted_68 = { class: "form-group card-metrics" };
const _hoisted_69 = { class: "row" };
const _hoisted_70 = ["id", "onUpdate:modelValue"];
const _hoisted_71 = { class: "col-sm offset-sm-3" };
const _hoisted_72 = ["onClick"];
const _hoisted_73 = { class: "action-item" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_QuillEditor = _resolveComponent("QuillEditor");
    const _component_VoiceSelector = _resolveComponent("VoiceSelector");
    const _component_assistant_selector = _resolveComponent("assistant-selector");
    const _component_AnimationControlsComponent = _resolveComponent("AnimationControlsComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[30] || (_cache[30] = _createElementVNode("label", {
                class: "control-label",
                for: "question_text"
            }, "Mobile Scenario Intro Text", -1)),
            _createVNode(_component_QuillEditor, {
                content: $data.content.question.mobileIntro,
                "onUpdate:content": _cache[0] || (_cache[0] = ($event) => (($data.content.question.mobileIntro) = $event)),
                contentType: 'html',
                modules: _ctx.editorModules,
                toolbar: $data.toolbarOpts,
                theme: "snow"
            }, null, 8, ["content", "modules", "toolbar"])
        ]),
        _createElementVNode("div", _hoisted_3, [
            _cache[32] || (_cache[32] = _createElementVNode("label", {
                class: "control-label",
                for: "question_text"
            }, "Question Text", -1)),
            _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (($data.content.question.editorType) = $event)),
                class: "form-control mb-2"
            }, _cache[31] || (_cache[31] = [
                _createElementVNode("option", { value: "text" }, "Text", -1),
                _createElementVNode("option", { value: "wysiwyg" }, "WYSIWYG", -1)
            ]), 512), [
                [_vModelSelect, $data.content.question.editorType]
            ]),
            ($data.content.question.editorType === 'wysiwyg')
                ? (_openBlock(), _createBlock(_component_QuillEditor, {
                    key: 0,
                    content: $data.content.question.text,
                    "onUpdate:content": _cache[2] || (_cache[2] = ($event) => (($data.content.question.text) = $event)),
                    contentType: 'html',
                    modules: _ctx.editorModules,
                    toolbar: $data.toolbarOpts,
                    theme: "snow"
                }, null, 8, ["content", "modules", "toolbar"]))
                : _createCommentVNode("", true),
            ($data.content.question.editorType === 'text')
                ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                    key: 1,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (($data.content.question.text) = $event)),
                    class: "form-control"
                }, null, 512)), [
                    [_vModelText, $data.content.question.text]
                ])
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
            _cache[33] || (_cache[33] = _createElementVNode("label", {
                class: "control-label",
                for: "question-text-classes"
            }, "Question Text CSS Classes", -1)),
            _withDirectives(_createElementVNode("input", {
                id: "question-text-classes",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (($data.content.questionTextClasses) = $event)),
                class: "form-control",
                type: "text"
            }, null, 512), [
                [_vModelText, $data.content.questionTextClasses]
            ])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _cache[34] || (_cache[34] = _createElementVNode("label", {
                class: "control-label",
                for: "question-text-classes"
            }, "User Input CSS Classes", -1)),
            _withDirectives(_createElementVNode("input", {
                id: "question-text-classes",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (($data.content.userInputClasses) = $event)),
                class: "form-control",
                type: "text"
            }, null, 512), [
                [_vModelText, $data.content.userInputClasses]
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _cache[36] || (_cache[36] = _createElementVNode("label", { class: "control-label" }, "Question Image", -1)),
            _createElementVNode("div", _hoisted_7, [
                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "input-group-prepend" }, [
                    _createElementVNode("a", {
                        class: "btn btn-primary text-white",
                        "data-input": "question-image",
                        "data-lfm": "image"
                    }, [
                        _createElementVNode("i", { class: "fa fa-image" })
                    ])
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                    id: "question-image",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => (($data.content.questionImage) = $event)),
                    class: "form-control",
                    type: "text"
                }, null, 512), [
                    [_vModelText, $data.content.questionImage]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_8, [
            _cache[37] || (_cache[37] = _createElementVNode("label", {
                class: "control-label",
                for: "compare-text-classes"
            }, "Compare Text CSS Classes", -1)),
            _withDirectives(_createElementVNode("input", {
                id: "compare-text-classes",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => (($data.content.compareTextClasses) = $event)),
                class: "form-control",
                type: "text"
            }, null, 512), [
                [_vModelText, $data.content.compareTextClasses]
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _cache[38] || (_cache[38] = _createElementVNode("label", {
                class: "control-label",
                for: "ideal-text-classes"
            }, "Ideal Response CSS Classes", -1)),
            _withDirectives(_createElementVNode("input", {
                id: "ideal-text-classes",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => (($data.content.idealResponseClasses) = $event)),
                class: "form-control",
                type: "text"
            }, null, 512), [
                [_vModelText, $data.content.idealResponseClasses]
            ])
        ]),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                        id: "display-as-chat",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => (($data.content.chatStyle) = $event)),
                        class: "mr-1",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, $data.content.chatStyle]
                    ]),
                    _cache[39] || (_cache[39] = _createElementVNode("label", {
                        class: "control-label",
                        for: "display-as-chat"
                    }, "Display as Chat Style Layout", -1))
                ]),
                _createElementVNode("div", _hoisted_13, [
                    _withDirectives(_createElementVNode("input", {
                        id: "multireply-chat",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => (($data.content.multiReply) = $event)),
                        class: "mr-1",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, $data.content.multiReply]
                    ]),
                    _cache[40] || (_cache[40] = _createElementVNode("label", {
                        class: "control-label",
                        for: "multireply-chat"
                    }, "Enable Multi Reply Threaded Message", -1))
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _withDirectives(_createElementVNode("input", {
                        id: "stt",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => (($data.content.question.stt) = $event)),
                        class: "mr-1",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, $data.content.question.stt]
                    ]),
                    _cache[41] || (_cache[41] = _createElementVNode("label", {
                        class: "control-label",
                        for: "stt"
                    }, "Enable Speech to Text", -1))
                ]),
                _createElementVNode("div", _hoisted_15, [
                    _withDirectives(_createElementVNode("input", {
                        id: "tryagain",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => (($data.content.tryAgain) = $event)),
                        class: "mr-1",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, $data.content.tryAgain]
                    ]),
                    _cache[42] || (_cache[42] = _createElementVNode("label", {
                        class: "control-label",
                        for: "tryagain"
                    }, "Enable Try Again", -1))
                ])
            ]),
            _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                    _cache[44] || (_cache[44] = _createElementVNode("label", { for: "message-alignment" }, "Message Alignment", -1)),
                    _withDirectives(_createElementVNode("select", {
                        id: "message-alignment",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => (($data.content.align) = $event)),
                        class: "form-control"
                    }, _cache[43] || (_cache[43] = [
                        _createElementVNode("option", { value: "left" }, "Left", -1),
                        _createElementVNode("option", { value: "right" }, "Right", -1)
                    ]), 512), [
                        [_vModelSelect, $data.content.align]
                    ])
                ])
            ])
        ]),
        ($data.content.multiReply)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                        _cache[45] || (_cache[45] = _createElementVNode("label", {
                            class: "control-label",
                            for: "min-reply-count"
                        }, "Min Reply Count", -1)),
                        _withDirectives(_createElementVNode("input", {
                            id: "min-reply-count",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => (($data.content.minReplyCount) = $event)),
                            class: "mr-1 form-control",
                            type: "number"
                        }, null, 512), [
                            [_vModelText, $data.content.minReplyCount]
                        ]),
                        _cache[46] || (_cache[46] = _createElementVNode("small", { class: "form-text text-muted" }, "Minimum number of replies user must send before global submit button will display.", -1))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _cache[47] || (_cache[47] = _createElementVNode("label", {
                            class: "control-label",
                            for: "max-reply-count"
                        }, "Max Reply Count", -1)),
                        _withDirectives(_createElementVNode("input", {
                            id: "max-reply-count",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => (($data.content.maxReplyCount) = $event)),
                            class: "mr-1 form-control",
                            type: "number"
                        }, null, 512), [
                            [_vModelText, $data.content.maxReplyCount]
                        ]),
                        _cache[48] || (_cache[48] = _createElementVNode("small", { class: "form-text text-muted" }, "Maximum number of replies user can send before send input is hidden.", -1))
                    ])
                ])
            ]))
            : _createCommentVNode("", true),
        _cache[72] || (_cache[72] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_22, [
            _cache[49] || (_cache[49] = _createElementVNode("label", { for: "tts" }, "Enable Text to Speech", -1)),
            _withDirectives(_createElementVNode("input", {
                id: "tts",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => (($data.content.ttsEnabled) = $event)),
                type: "checkbox"
            }, null, 512), [
                [_vModelCheckbox, $data.content.ttsEnabled]
            ])
        ]),
        ($data.content.ttsEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _cache[52] || (_cache[52] = _createElementVNode("label", null, "Voices", -1)),
                _createElementVNode("table", _hoisted_24, [
                    _cache[51] || (_cache[51] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Default"),
                            _createElementVNode("th", null, "Voice"),
                            _createElementVNode("th", null, "Character Name"),
                            _createElementVNode("th", null, "Actions")
                        ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.ttsVoices, (voice, index) => {
                            return (_openBlock(), _createElementBlock("tr", null, [
                                _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "checkbox",
                                        "onUpdate:modelValue": ($event) => ((voice.default) = $event)
                                    }, null, 8, _hoisted_25), [
                                        [_vModelCheckbox, voice.default]
                                    ])
                                ]),
                                _createElementVNode("td", null, [
                                    _createVNode(_component_VoiceSelector, {
                                        id: voice.voiceName,
                                        speed: voice.speed,
                                        "model-id": voice.opts?.modelId,
                                        stability: voice.opts?.stability,
                                        "similarity-boost": voice.opts?.similarityBoost,
                                        "style-exaggeration": voice.opts?.styleExaggeration,
                                        "use-speaker-boost": voice.opts?.useSpeakerBoost,
                                        "id-index": `${index}`,
                                        onHandleVoiceChange: _cache[17] || (_cache[17] = ($event) => ($options.handleVoiceChange($event)))
                                    }, null, 8, ["id", "speed", "model-id", "stability", "similarity-boost", "style-exaggeration", "use-speaker-boost", "id-index"])
                                ]),
                                _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event) => ((voice.characterKey) = $event),
                                        class: "form-control"
                                    }, null, 8, _hoisted_26), [
                                        [_vModelText, voice.characterKey]
                                    ])
                                ]),
                                _createElementVNode("td", null, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-danger",
                                        onClick: ($event) => ($options.removeVoice(index)),
                                        "aria-label": "Remove Voice"
                                    }, _cache[50] || (_cache[50] = [
                                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                    ]), 8, _hoisted_27)
                                ])
                            ]));
                        }), 256))
                    ])
                ]),
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary mt-2",
                    onClick: _cache[18] || (_cache[18] = ($event) => ($options.addVoice()))
                }, "Add Voice")
            ]))
            : _createCommentVNode("", true),
        _cache[73] || (_cache[73] = _createElementVNode("hr", null, null, -1)),
        _createVNode(_component_assistant_selector, {
            id: $data.content.assistantId,
            type: 'feedback',
            class: "mt-4",
            onHandleChange: _cache[19] || (_cache[19] = ($event) => ($data.content.assistantId = $event))
        }, null, 8, ["id"]),
        _createElementVNode("div", _hoisted_28, [
            _cache[53] || (_cache[53] = _createElementVNode("label", { class: "control-label" }, "Feedback Assistant Prompt", -1)),
            _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => (($data.content.question.promptFeedbackAssistant) = $event)),
                class: "form-control",
                style: { "height": "200px" }
            }, null, 512), [
                [_vModelText, $data.content.question.promptFeedbackAssistant]
            ]),
            _cache[54] || (_cache[54] = _createElementVNode("small", { class: "form-text text-muted" }, "Provide detailed instructions on how you'd like the AI to evaluate a user's input and provide textual feedback. This is also where you can set character limits for feedback (i.e. Please limit feedback to 500 characters or less).", -1))
        ]),
        _createElementVNode("div", _hoisted_29, [
            _cache[55] || (_cache[55] = _createElementVNode("label", {
                for: "",
                class: "control-label"
            }, "Stream Error Recovery Message", -1)),
            _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => (($data.content.question.streamErrorRecoveryMsg) = $event))
            }, null, 512), [
                [_vModelText, $data.content.question.streamErrorRecoveryMsg]
            ])
        ]),
        _createElementVNode("div", _hoisted_30, [
            _cache[56] || (_cache[56] = _createElementVNode("label", { class: "control-label" }, "Scoring Assistant Prompt", -1)),
            _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => (($data.content.question.promptScoringAssistant) = $event)),
                class: "form-control",
                style: { "height": "200px" }
            }, null, 512), [
                [_vModelText, $data.content.question.promptScoringAssistant]
            ]),
            _cache[57] || (_cache[57] = _createElementVNode("small", { class: "form-text text-muted" }, "Provide detailed instructions on how you'd like the AI to evaluate a user's input and assign each meter a score of poor, satisfactory, good, or excellent.", -1))
        ]),
        _cache[74] || (_cache[74] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("p", { class: "font-weight-bold mb-0" }, "AI Grade Meter Effects"),
            _createElementVNode("small", { class: "form-text text-muted" }, "The AI will grade a user's response as poor, satisfactory, good, or excellent. Assign values to meters at each grade level to control how each grade will effect a user's score.")
        ], -1)),
        _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
                _cache[58] || (_cache[58] = _createElementVNode("div", { class: "col-2 font-weight-bold" }, "Poor", -1)),
                _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.poorMeters, (meter) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(['badge', 'badge-primary', meter.id])
                                }, _toDisplayString(meter.id), 3),
                                _withDirectives(_createElementVNode("input", {
                                    id: meter.id,
                                    "onUpdate:modelValue": ($event) => ((meter.value) = $event),
                                    class: "form-control",
                                    type: "number"
                                }, null, 8, _hoisted_36), [
                                    [_vModelText, meter.value]
                                ])
                            ]));
                        }), 256))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
                _cache[59] || (_cache[59] = _createElementVNode("div", { class: "col-2 font-weight-bold" }, "Satisfactory", -1)),
                _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.satisfactoryMeters, (meter) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(['badge', 'badge-primary', meter.id])
                                }, _toDisplayString(meter.id), 3),
                                _withDirectives(_createElementVNode("input", {
                                    id: meter.id,
                                    "onUpdate:modelValue": ($event) => ((meter.value) = $event),
                                    class: "form-control",
                                    type: "number"
                                }, null, 8, _hoisted_42), [
                                    [_vModelText, meter.value]
                                ])
                            ]));
                        }), 256))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
                _cache[60] || (_cache[60] = _createElementVNode("div", { class: "col-2 font-weight-bold" }, "Good", -1)),
                _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.goodMeters, (meter) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(['badge', 'badge-primary', meter.id])
                                }, _toDisplayString(meter.id), 3),
                                _withDirectives(_createElementVNode("input", {
                                    id: meter.id,
                                    "onUpdate:modelValue": ($event) => ((meter.value) = $event),
                                    class: "form-control",
                                    type: "number"
                                }, null, 8, _hoisted_48), [
                                    [_vModelText, meter.value]
                                ])
                            ]));
                        }), 256))
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
                _cache[61] || (_cache[61] = _createElementVNode("div", { class: "col-2 font-weight-bold" }, "Excellent", -1)),
                _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.excellentMeters, (meter) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                _createElementVNode("span", {
                                    class: _normalizeClass(['badge', 'badge-primary', meter.id])
                                }, _toDisplayString(meter.id), 3),
                                _withDirectives(_createElementVNode("input", {
                                    id: meter.id,
                                    "onUpdate:modelValue": ($event) => ((meter.value) = $event),
                                    class: "form-control",
                                    type: "number"
                                }, null, 8, _hoisted_54), [
                                    [_vModelText, meter.value]
                                ])
                            ]));
                        }), 256))
                    ])
                ])
            ])
        ]),
        _cache[75] || (_cache[75] = _createElementVNode("div", null, [
            _createElementVNode("hr")
        ], -1)),
        _cache[76] || (_cache[76] = _createElementVNode("div", { class: "mb-4" }, [
            _createElementVNode("p", { class: "font-weight-bold mb-0" }, "Self Scoring Fallback"),
            _createElementVNode("small", { class: "form-text text-muted" }, "In the scenario where OpenAI returns errors or is unavailable this question type can fallback to a self scoring mode using the configuration below.")
        ], -1)),
        _createVNode(_component_AnimationControlsComponent, { content: $data.content }, null, 8, ["content"]),
        _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("button", {
                        class: "btn btn-default",
                        type: "button",
                        onClick: _cache[23] || (_cache[23] =
                            //@ts-ignore
                            (...args) => ($options.addResponse && $options.addResponse(...args)))
                    }, _cache[62] || (_cache[62] = [
                        _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
                        _createTextVNode(" Add Scoring Option ")
                    ]))
                ]),
                _createElementVNode("div", _hoisted_58, [
                    _withDirectives(_createElementVNode("input", {
                        id: "force-self-score",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => (($data.content.question.forceSelfScore) = $event)),
                        class: "mr-1",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, $data.content.question.forceSelfScore]
                    ]),
                    _cache[63] || (_cache[63] = _createElementVNode("label", {
                        class: "control-label",
                        for: "force-self-score"
                    }, "Force Self Scoring", -1))
                ]),
                _createElementVNode("div", _hoisted_59, [
                    _withDirectives(_createElementVNode("input", {
                        id: "multiselect",
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => (($data.content.question.multiselect) = $event)),
                        class: "mr-1",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, $data.content.question.multiselect]
                    ]),
                    _cache[64] || (_cache[64] = _createElementVNode("label", {
                        class: "control-label",
                        for: "multiselect"
                    }, "Multiple Select (with Submit)", -1))
                ]),
                _createElementVNode("div", _hoisted_60, [
                    _withDirectives(_createElementVNode("input", {
                        id: "show-0-val-outcomes",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => (($data.content.showOutcomeOfZero) = $event)),
                        class: "mr-1",
                        type: "checkbox"
                    }, null, 512), [
                        [_vModelCheckbox, $data.content.showOutcomeOfZero]
                    ]),
                    _cache[65] || (_cache[65] = _createElementVNode("label", {
                        class: "control-label",
                        for: "show-0-val-outcomes"
                    }, "Show outcomes with value of 0", -1))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_61, [
            _cache[66] || (_cache[66] = _createElementVNode("label", {
                class: "control-label",
                for: "ideal_text"
            }, "Fallback Ideal Response", -1)),
            _createVNode(_component_QuillEditor, {
                content: $data.content.question.idealResponse,
                "onUpdate:content": _cache[27] || (_cache[27] = ($event) => (($data.content.question.idealResponse) = $event)),
                contentType: 'html',
                modules: _ctx.editorModules,
                toolbar: $data.toolbarOpts,
                theme: "snow"
            }, null, 8, ["content", "modules", "toolbar"])
        ]),
        _createElementVNode("div", _hoisted_62, [
            _cache[67] || (_cache[67] = _createElementVNode("label", {
                class: "control-label",
                for: "point_selection_text"
            }, "Fallback Compare Text Directions", -1)),
            _createVNode(_component_QuillEditor, {
                content: $data.content.question.compareTextDirections,
                "onUpdate:content": _cache[28] || (_cache[28] = ($event) => (($data.content.question.compareTextDirections) = $event)),
                contentType: 'html',
                modules: _ctx.editorModules,
                toolbar: $data.toolbarOpts,
                theme: "snow"
            }, null, 8, ["content", "modules", "toolbar"])
        ]),
        _createElementVNode("div", _hoisted_63, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.content.question.responses, (response, index) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "card content-list-item"
                }, [
                    _createElementVNode("div", _hoisted_64, _toDisplayString(_ctx.alphabet[index]), 1),
                    _createElementVNode("div", _hoisted_65, [
                        _createElementVNode("div", _hoisted_66, [
                            _createElementVNode("div", _hoisted_67, [
                                _cache[68] || (_cache[68] = _createElementVNode("label", {
                                    class: "control-label",
                                    for: "label"
                                }, "Choice Text", -1)),
                                _createVNode(_component_QuillEditor, {
                                    content: response.label,
                                    "onUpdate:content": ($event) => ((response.label) = $event),
                                    contentType: 'html',
                                    options: $data.editorOptsLite,
                                    theme: "snow"
                                }, null, 8, ["content", "onUpdate:content", "options"])
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                            _cache[70] || (_cache[70] = _createElementVNode("label", {
                                class: "control-label",
                                for: "metrics"
                            }, "Meter Effects", -1)),
                            _createElementVNode("div", _hoisted_69, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(response.meters, (meter) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: meter.id,
                                        class: "col-sm"
                                    }, [
                                        _createElementVNode("span", {
                                            class: _normalizeClass(['badge', 'badge-primary', meter.id])
                                        }, _toDisplayString(meter.id), 3),
                                        _withDirectives(_createElementVNode("input", {
                                            id: meter.id,
                                            "onUpdate:modelValue": ($event) => ((meter.value) = $event),
                                            class: "form-control",
                                            type: "number"
                                        }, null, 8, _hoisted_70), [
                                            [_vModelText, meter.value]
                                        ])
                                    ]));
                                }), 128)),
                                _createElementVNode("div", _hoisted_71, [
                                    _cache[69] || (_cache[69] = _createElementVNode("label", { class: "control-label" }, " ", -1)),
                                    _createElementVNode("button", {
                                        class: "btn btn-danger btn-block",
                                        type: "button",
                                        onClick: ($event) => ($options.remove(response, index))
                                    }, "Remove ", 8, _hoisted_72)
                                ])
                            ])
                        ])
                    ])
                ]));
            }), 128))
        ]),
        _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_73, [
                _createElementVNode("button", {
                    class: "btn btn-default",
                    type: "button",
                    onClick: _cache[29] || (_cache[29] =
                        //@ts-ignore
                        (...args) => ($options.addResponse && $options.addResponse(...args)))
                }, _cache[71] || (_cache[71] = [
                    _createElementVNode("i", { class: "fa fa-plus" }, null, -1),
                    _createTextVNode(" Add Scoring Option ")
                ]))
            ])
        ], 512), [
            [_vShow, $data.content.question.responses.length > 0]
        ])
    ]));
}
